import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.css';

const Filters = ({children, className, style, childrenStyle}) => (
  <div className={classNames('filters', className)} style={style}>
    {children.map((element, i) => (
      <div
        key={`filter-element-${i}`}
        className="filter-element"
        style={childrenStyle}>
        {element}
      </div>
    ))}
  </div>
);

Filters.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

Filters.defaultProps = {
  className: '',
  style: {},
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Filters/index.js